/**
 * FwtvStudioAdmin — everything the retired faith-works-tv/admin.html page did,
 * now inside the app: command centre, pipeline, schedule, media, approvals,
 * intake and the studio team.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import {
  Gauge, Film, CalendarClock, UploadCloud, ShieldCheck, Inbox, Users,
} from 'lucide-react';
import CommandCentre from '@/components/fwtv/studio/CommandCentre';
import EpisodePipeline from '@/components/fwtv/studio/EpisodePipeline';
import BroadcastSchedule from '@/components/fwtv/studio/BroadcastSchedule';
import MediaReadiness from '@/components/fwtv/studio/MediaReadiness';
import PublishingApprovals from '@/components/fwtv/studio/PublishingApprovals';
import AudienceIntake from '@/components/fwtv/studio/AudienceIntake';
import StudioTeamRoles from '@/components/fwtv/studio/StudioTeamRoles';

const TABS = [
  ['centre', 'Command centre', Gauge, CommandCentre],
  ['pipeline', 'Episode pipeline', Film, EpisodePipeline],
  ['schedule', 'Broadcast schedule', CalendarClock, BroadcastSchedule],
  ['media', 'Media readiness', UploadCloud, MediaReadiness],
  ['approvals', 'Approvals', ShieldCheck, PublishingApprovals],
  ['intake', 'Audience intake', Inbox, AudienceIntake],
  ['team', 'Team & roles', Users, StudioTeamRoles],
];

export default function FwtvStudioAdmin() {
  return (
    <div className="p-6 max-w-[1500px] mx-auto space-y-6" data-testid="fwtv-studio-admin">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold">Faith Works TV — Studio</h1>
          <p className="mt-1 text-sm text-slate-600">
            Production, scheduling and publishing administration. All studio data and settings live
            here now — the standalone admin page is retired.
          </p>
        </div>
        <div className="flex flex-wrap gap-2 text-xs">
          <Link to="/admin/fwtv" data-testid="studio-content-link"
                className="rounded-full border px-3 py-1 hover:bg-slate-50">Content &amp; programmes</Link>
          <Link to="/admin/fwtv/premium" data-testid="studio-premium-link"
                className="rounded-full border border-amber-300 bg-amber-50 px-3 py-1 font-medium text-amber-800 hover:bg-amber-100">
            Premium &amp; subscribers
          </Link>
        </div>
      </div>

      <Tabs defaultValue="centre">
        <TabsList className="flex flex-wrap h-auto">
          {TABS.map(([value, label, Icon]) => (
            <TabsTrigger key={value} value={value} data-testid={`studio-tab-${value}`}>
              <Icon className="h-4 w-4 mr-1" /> {label}
            </TabsTrigger>
          ))}
        </TabsList>
        {TABS.map(([value, , , Panel]) => (
          <TabsContent key={value} value={value} className="mt-6">
            <Panel />
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
